
<div class="block">
    <div class="required">
        <label>{{ 'Components.EnterSMSCode.PhoneHeaderText' | translate }}</label>
    </div>

    <app-phone-input [readonly]="true"
                     [phoneValueWithRegion]="phoneValueWithRegion"
                     (phoneValueWithRegionChange)="phoneValueWithRegionChange.emit($event)">
    </app-phone-input>

    <div class="text-muted">{{ 'Components.EnterSMSCode.PhoneDescriptionText' | translate }}</div>

</div>

<div class="block" *ngIf="!showCaptcha">
    <div class="required">
        <label>{{ 'Components.EnterSMSCode.ConfirmCodeHeaderText' | translate }}</label>
    </div>

    <input class="form-control"
           name="Code"
           type="text"
           autocomplete="off"
           placeholder="****"
           value=""
           [(ngModel)]="confirmCodeValue">
    
</div>

<div class="block">
    <label>
        {{confirmCodeLifeTimeText}}
    </label>
    <div *ngIf="showCaptcha">
        <app-captcha #captchaComponent refreshOnInit="showCaptcha"></app-captcha>
        <div class="form-group mt-3">
            <label for="captchaCode">{{ 'Common.CaptchaText' | translate }}</label>
            <input class="form-control"
                   id="captchaCode"
                   name="captchaCode"
                   type="text"
                   autocomplete="off"
                   placeholder="{{ 'Common.CaptchaText' | translate }}"
                   [(ngModel)]="captchaCode">
        </div>
    </div>

</div>

<button class="btn btn-primary"
        name="Operation"
        type="submit"
        (click)="submitButtonClick($event)"
        [disabled]="submitProcessing">
    {{submitButtonText}}
</button>

<button class="btn btn-primary ml-2"
        name="Operation"
        type="submit"
        (click)="reSendCodeButtonClick($event)"
        [disabled]="reSendProcessing"
        [style.display]="confirmCodeAllowReSend ? 'inline-block' : 'none'">
    {{ 'Components.EnterSMSCode.ReSendButtonText' | translate }}
</button>

<span *ngIf="errorText"
      class="text-danger error">
    {{errorText}}
</span>
